import OptionalGenericPOIDTO from "../../models/teleport/OptionalGenericPOIDTO";
import axios from "axios";
import BackendClient from "../../BackendClient";

export function amIAtATeleportingPOI(client: BackendClient): Promise<OptionalGenericPOIDTO> {
    const headers = {
      'Authorization': `${client.getAuthEntity()} ${client.getAuthToken()}`,
    };

    return new Promise<OptionalGenericPOIDTO>((resolve, reject) => {
      axios.get(`${client.getBackendUrl()}${BackendClient.AmIAtATeleportingPOI}`, {headers: headers})
        .then((response) => resolve(response.data))
        .catch((reason) => {
          console.log(`Exception when trying to get am i at a teleporting poi: ${JSON.stringify(reason)}`)
          reject(reason);
        });
    });
  }